<template>
	<div class="row" v-show="!loading">
		<div class="col-lg-12">
			<div class="box">
				<div class="box-header">
					<h2 class="box-title">Ferment Simulator Setup</h2>
				</div>
				<div class="box-body">

					<form class="form-horizontal form-col-tight">
						<fieldset>

							<legend>Data Entry</legend>

							<div class="row row-clear-md-6-lg-4">
								<div class="col-md-8 col-lg-8">
									<input-text type="text" name="dap_grade" :vmodel.sync="simulatorSetup.dap_grade" :spinner="true" postfix="% N" label="DAP Grade"></input-text>

									<input-text type="text" name="default_yan" :vmodel.sync="simulatorSetup.default_yan" :spinner="true" label="Default YAN (if unknown)" postfix="mg/L"></input-text>
								</div>
							</div>

							<div class="row">
								<div class="col-md-6 col-lg-6">

									<div class="form-group">
										<label for="data_temperature_units" class="col-xs-4 col-md-4 control-label control-label-toggle">Temperature Units</label>
										<div class="col-xs-8 col-md-8">
											<input type="checkbox" v-toggle="simulatorSetup.temp_units" :value="simulatorSetup.temp_units"
												data-on="&deg;Celsius"
												data-off="&deg;Fahrenheit"
												data-onstyle="info"
												data-offstyle="default"
											/>
										</div>
									</div>

									<div class="form-group">
										<label for="data_sugar_units" class="col-xs-4 col-md-4 control-label control-label-toggle">Sugar Units</label>
										<div class="col-xs-8 col-md-8">
											<input type="checkbox" v-toggle="simulatorSetup.sugar_units" :value="simulatorSetup.sugar_units"
												data-on="&deg;Baume"
												data-off="&deg;Brix"
												data-onstyle="info"
												data-offstyle="default"
											/>
										</div>
									</div>

									<div class="form-group">
										<label for="data_secondary_sugar_units" class="col-xs-4 col-md-4 control-label control-label-toggle">Secondary Sugar Units</label>
										<div class="col-xs-8 col-md-8">
											<input type="checkbox" v-toggle="secondarySugarUnits" :value="secondarySugarUnits"
												data-on="SG"
												data-off="RS (g/L)"
												data-onstyle="info"
												data-offstyle="default"
											/>
										</div>
									</div>

									<div class="form-group">
										<label for="data_red_sampling_frequency" class="col-xs-4 col-md-4 control-label control-label-toggle">Red Sampling Frequency</label>
										<div class="col-xs-8 col-md-8">
											<input-text type="text" name="data_red_sampling_frequency" :vmodel.sync="simulatorSetup.red_sampling_freq" :spinner="true" postfix="per day"></input-text>
											<!--
											<input type="checkbox" v-toggle="simulatorSetup.red_sampling_freq" :value="simulatorSetup.red_sampling_freq"
												data-on="Twice"
												data-off="Once"
												data-onstyle="info"
												data-offstyle="default"
											/> &nbsp; &nbsp; per day
											-->
										</div>
									</div>

									<div class="form-group">
										<label for="data_white_sampling_frequency" class="col-xs-4 col-md-4 control-label control-label-toggle">White Sampling Frequency</label>
										<div class="col-xs-8 col-md-8">
											<input-text type="text" name="data_white_sampling_frequency" :vmodel.sync="simulatorSetup.white_sampling_freq" :spinner="true" postfix="per day"></input-text>
											<!--
											<input type="checkbox" v-toggle="simulatorSetup.white_sampling_freq" :value="simulatorSetup.white_sampling_freq"
												data-on="Twice"
												data-off="Once"
												data-onstyle="info"
												data-offstyle="default"
											/> &nbsp; &nbsp; per day
											-->
										</div>
									</div>

									<div class="form-group">
										<label for="data_date_day_display" class="col-xs-4 col-md-4 control-label control-label-toggle">Date / Day Display</label>
										<div class="col-xs-8 col-md-8">
											<input type="checkbox" v-toggle="simulatorSetup.date_day_display" :value="simulatorSetup.date_day_display"
												data-on="Date"
												data-off="Day"
												data-onstyle="info"
												data-offstyle="default"
											/>
										</div>
									</div>

								</div>
							</div><!-- /.row -->
						</fieldset>
						<fieldset>
							<legend>Wine Description</legend>
							<div class="form-group">
								<label for="wine_name" class="col-xs-6 col-md-3 col-lg-2 control-label control-label-toggle">Wine Name</label>
								<div class="col-xs-12 col-md-4 col-lg-3">
									<input type="text" class="form-control form-control-toggle-top" placeholder="Rename" v-model="simulatorSetup.custom_wine_name">
								</div>
							</div>
							<div class="form-group">
								<label for="wine_blend_code" class="col-xs-6 col-md-3 col-lg-2 control-label control-label-toggle">Blend Code</label>
								<div class="col-xs-6 col-md-2 col-lg-1">
									<div class="checkbox">
										<input type="checkbox" v-toggle="simulatorSetup.blend_code" :value="simulatorSetup.blend_code"
											data-on="Show"
											data-off="Hide"
											data-onstyle="info"
											data-offstyle="default"
										/>
									</div>
								</div>
								<div class="col-xs-12 col-sm-offset-6 col-sm-6 col-md-offset-1 col-md-4 col-lg-3 col-lg-offset-1">
									<input type="text" class="form-control form-control-toggle-top" placeholder="Rename" v-model="simulatorSetup.custom_blend_code">
								</div>
							</div>
							<div class="form-group">
								<label for="wine_batch_code" class="col-xs-6 col-md-3 col-lg-2 control-label control-label-toggle">Batch Code</label>
								<div class="col-xs-6 col-md-2 col-lg-1">
									<div class="checkbox">
										<input type="checkbox" v-toggle="simulatorSetup.batch_code" :value="simulatorSetup.batch_code"
											data-on="Show"
											data-off="Hide"
											data-onstyle="info"
											data-offstyle="default"
										/>
									</div>
								</div>
								<div class="col-xs-12 col-sm-offset-6 col-sm-6 col-md-offset-1 col-md-4 col-lg-3 col-lg-offset-1">
									<input type="text" class="form-control form-control-toggle-top" placeholder="Rename" v-model="simulatorSetup.custom_batch_code">
								</div>
							</div>
							<div class="form-group">
								<label for="country" class="col-xs-6 col-md-3 col-lg-2 control-label control-label-toggle">Country</label>
								<div class="col-xs-12 col-md-4 col-lg-3 fix-top">
									<input-select
										:select2="true"
										:options="countries"
										name="country_id"
										:vmodel.sync="simulatorSetup.country_id"
									></input-select>
								</div>
							</div>
						</fieldset>
						<fieldset>
							<legend>Dashboard Customization</legend>

							<div class="row row-clear-md-6-lg-4">
								<div class="col-md-6 col-lg-4">
									<div class="form-group">
										<label for="dashboard_tank_name" class="col-xs-6 col-md-6 control-label control-label-toggle">Tank Name</label>
										<div class="col-xs-6 col-md-6">
											<div class="checkbox">
												<input type="checkbox" v-toggle="simulatorSetup.dashboard_tank_name" :value="simulatorSetup.dashboard_tank_name"
													data-on="Show"
													data-off="Hide"
													data-onstyle="info"
													data-offstyle="default"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6 col-lg-4">
									<div class="form-group">
										<label for="dashboard_wine_name" class="col-xs-6 col-md-6 control-label control-label-toggle">Wine Name</label>
										<div class="col-xs-6 col-md-6">
											<div class="checkbox">
												<input type="checkbox" v-toggle="simulatorSetup.dashboard_wine_name" :value="simulatorSetup.dashboard_wine_name"
													data-on="Show"
													data-off="Hide"
													data-onstyle="info"
													data-offstyle="default"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6 col-lg-4">
									<div class="form-group">
										<label for="dashboard_batch_code" class="col-xs-6 col-md-6 control-label control-label-toggle">Batch Code</label>
										<div class="col-xs-6 col-md-6">
											<div class="checkbox">
												<input type="checkbox"  v-toggle="simulatorSetup.dashboard_batch_code" :value="simulatorSetup.dashboard_batch_code"
													data-on="Show"
													data-off="Hide"
													data-onstyle="info"
													data-offstyle="default"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6 col-lg-4">
									<div class="form-group">
										<label for="dashboard_blend_code" class="col-xs-6 col-md-6 control-label control-label-toggle">Blend Code</label>
										<div class="col-xs-6 col-md-6">
											<div class="checkbox">
												<input type="checkbox" v-toggle="simulatorSetup.dashboard_blend_code" :value="simulatorSetup.dashboard_blend_code"
													data-on="Show"
													data-off="Hide"
													data-onstyle="info"
													data-offstyle="default"
												/>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6 col-lg-4">
									<div class="form-group">
										<label for="dashboard_varietal" class="col-xs-6 col-md-6 control-label control-label-toggle">Varietal</label>
										<div class="col-xs-6 col-md-6">
											<div class="checkbox">
												<input type="checkbox" v-toggle="simulatorSetup.dashboard_varietal" :value="simulatorSetup.dashboard_varietal"
													data-on="Show"
													data-off="Hide"
													data-onstyle="info"
													data-offstyle="default"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</fieldset>
					</form>
				</div>
			</div>
		</div>

		<winemakers
			:site="site"
			:winemakers="simulatorSetup.winemakers"
			:loading="loading"
		></winemakers>
	</div>
</template>

<script>
	import { site, simulatorSetup, loading, countries } from 'vx/getters'
	import { Settings as SettingActions, SimulatorSetup as SimulatorSetupActions, App as AppActions } from 'vx/actions'
	import Notify from 'utils/notify'
	import Winemakers from './partials/winemakers'

	export default {
		vuex: {
			actions: {
				getSimulator: SimulatorSetupActions.get,
				updateSimulator: SimulatorSetupActions.update,
				setTitle: AppActions.title,
				allCountries: SettingActions.allCountries,
			},

			getters: {
				countries,
				site,
				simulatorSetup,
				loading
			}
		},

		computed: {
			secondarySugarUnits: {
				get() {
					if (this.simulatorSetup.secondary_sugar_units == 'sg') {
						return true
					} else {
						return false
					}
				},

				set(value) {
					if (value) {
						this.simulatorSetup.secondary_sugar_units = 'sg'
					} else {
						this.simulatorSetup.secondary_sugar_units = 'rs'
					}
				}
			}
		},

		route: {
			activate() {
				this.$dispatch('loading');
			},

			data() {
				this.allCountries().then(() => {
					this.getSimulator(this.site.id).then(() => {
						this.$dispatch('loaded');
					});
				});
			}
		},

		data() {
			return {
				test: false,
				inputTimeout: null,
				dirty: false
			}
		},

		ready() {
			this.setTitle('Simulator Setup');

			// sampling frequencies validation
			['red', 'white'].forEach(type => {
				const freqType = type + '_sampling_freq'

				this.$watch(`simulatorSetup.${freqType}`, function (val, oldVal) {
					if (val) {
						val = parseInt(val, 10);

						if (val === 0 || !val) {
							Notify.warning('Simpling Frequency cannot be 0 or empty');
							// retrieve to old value
							this.simulatorSetup[freqType] = oldVal
						} else {
							this.autoSave();
						}
					}
				})
			})

			this.$watch('simulatorSetup.country_id', function (val) {
				if (val) {
					this.autoSave();
				}
			})

			$('.toggle').on('click', event => this.autoSave());

			$('input').on('change keyup', event => {
				clearTimeout(this.inputTimeout);

				let key = event.which;

				// do not save if left/right arrow or tab is pressed
				if (key != 37 && key != 39 && key != 9){
					this.setInputTimeout();
				}
			});
		},

		methods: {
			autoSave() {
				clearTimeout(this.inputTimeout);
				this.setInputTimeout();
			},

			setInputTimeout() {
				this.inputTimeout = setTimeout(() => {
					this.save();
				}, 1500);
			},

			save() {
				console.log(this.site.id);
				console.log(this.simulatorSetup.id);
				this.updateSimulator(this.site.id, this.simulatorSetup.id, this.simulatorSetup).then(() => {
					Notify.success(`Simulator has been updated.`);
				});
			}
		},

		components: {
			Winemakers
		}
	}
</script>

<style scoped>
	.fix-top {
		margin-top: 10px;
	}
</style>



// WEBPACK FOOTER //
// index.vue?05043784